var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverLicense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6666,
    y: 36.2667,
    width: 73.0667,
    height: 20.8,
    rx: 1.06667,
    stroke: "#FFCE44",
    strokeWidth: 2.13333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.533333,
    y: 0.533333,
    width: 94.9333,
    height: 62.9333,
    rx: 1.6,
    stroke: "#6C7782",
    strokeWidth: 1.06667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.400024,
    y: 8,
    width: 95.2,
    height: 11.2,
    fill: "#6C7782"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70.3745,
    y1: 40,
    x2: 70.3745,
    y2: 52.8,
    stroke: "#47525D",
    strokeWidth: 0.533333
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 72.1473,
    y1: 40,
    x2: 72.1473,
    y2: 52.8,
    stroke: "#47525D",
    strokeWidth: 1.06667
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 74.187,
    y1: 40,
    x2: 74.187,
    y2: 52.8,
    stroke: "#47525D",
    strokeWidth: 2.13333
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 76.3995,
    y1: 40,
    x2: 76.3995,
    y2: 52.8,
    stroke: "#47525D",
    strokeWidth: 0.533333
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 78.7057,
    y1: 40,
    x2: 78.7057,
    y2: 52.8,
    stroke: "#47525D",
    strokeWidth: 2.13333
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.266667,
    x2: 12.8,
    y2: -0.266667,
    transform: "matrix(0 1 1 0 24.0632 40)",
    stroke: "#47525D",
    strokeWidth: 0.533333
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.533333,
    x2: 12.8,
    y2: -0.533333,
    transform: "matrix(0 1 1 0 22.557 40)",
    stroke: "#47525D",
    strokeWidth: 1.06667
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -1.06667,
    x2: 12.8,
    y2: -1.06667,
    transform: "matrix(0 1 1 0 21.0507 40)",
    stroke: "#47525D",
    strokeWidth: 2.13333
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.266667,
    x2: 12.8,
    y2: -0.266667,
    transform: "matrix(0 1 1 0 18.0383 40)",
    stroke: "#47525D",
    strokeWidth: 0.533333
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    y1: -1.06667,
    x2: 12.8,
    y2: -1.06667,
    transform: "matrix(0 1 1 0 16.532 40)",
    stroke: "#47525D",
    strokeWidth: 2.13333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5297 41.2797V43.8446H54.5833V42.5576H53.5564V41.2797H52.5297Z",
    fill: "#47525D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5578 40.0016V41.2795H55.6115V40.0016H53.5578Z",
    fill: "#47525D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5859 43.844V46.3995H56.6396V45.1216H55.6127V43.8438L54.5859 43.844Z",
    fill: "#47525D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4421 41.2797V42.5576H50.4691V43.8446H51.5033V41.2797H49.4421Z",
    fill: "#47525D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5015 40.0016V41.2807H52.5294V40.0016H51.5015Z",
    fill: "#47525D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.389 42.5578V46.4006H48.416V45.1227H49.4429V43.8448H48.416V42.5578H47.389Z",
    fill: "#47525D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5297 46.3979V45.1187H53.5576V46.3979H52.5297Z",
    fill: "#47525D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6828 42.5588V41.2797H59.7107V42.5588H58.6828Z",
    fill: "#47525D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.639 42.5578V45.1227H57.666V42.5578H56.639Z",
    fill: "#47525D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4421 45.1219V46.3998H51.5033V45.1219H49.4421Z",
    fill: "#47525D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5015 43.8391V45.1182H52.5294V43.8391H51.5015Z",
    fill: "#47525D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6078 40V41.2791H58.6357V40H57.6078Z",
    fill: "#47525D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.614 42.5604V41.2812H56.6419V42.5604H55.614Z",
    fill: "#47525D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.389 40.0016V41.2795H49.4427V40.0016H47.389Z",
    fill: "#47525D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7203 45.0859V46.3557H62.7684V45.0859H60.7203Z",
    fill: "#47525D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.739 46.3569V45.0859H58.7176V46.3569H59.739Z",
    fill: "#47525D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7609 43.8156V45.0866H59.7395V43.8156H60.7609Z",
    fill: "#47525D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8078 43.81V42.5391H63.8292V43.81H62.8078Z",
    fill: "#47525D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8203 40.0016V42.5408H64.8407V40.0016H63.8203Z",
    fill: "#47525D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8422 42.5406V45.0892H65.8698V43.8194H66.8902V42.5406H64.8422Z",
    fill: "#47525D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.889 46.3569V45.0859H68.9104V46.3569H67.889Z",
    fill: "#47525D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8203 46.3569V45.0859H64.8417V46.3569H63.8203Z",
    fill: "#47525D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8672 43.8156V45.0866H67.8886V43.8156H66.8672Z",
    fill: "#47525D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9078 41.2703V43.8189H68.9282V41.2703H67.9078Z",
    fill: "#47525D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8672 40.0016V41.2713H67.9078V40.0016H65.8672Z",
    fill: "#47525D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7172 42.5453V43.8151H60.7577V42.5453H58.7172Z",
    fill: "#47525D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7203 40V42.5486H61.7407V41.2698H62.7611V40H60.7205H60.7203Z",
    fill: "#47525D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2469 41.2797V43.8446H32.3005V42.5576H31.2736V41.2797H30.2469Z",
    fill: "#47525D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.275 40.0016V41.2795H33.3287V40.0016H31.275Z",
    fill: "#47525D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3031 43.844V46.3995H34.3568V45.1216H33.3298V43.8438L32.3031 43.844Z",
    fill: "#47525D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1594 41.2797V42.5576H28.1863V43.8446H29.2206V41.2797H27.1594Z",
    fill: "#47525D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 40.0016V41.2807H30.2467V40.0016H29.2188Z",
    fill: "#47525D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1063 42.5578V46.4006H26.1332V45.1227H27.1601V43.8448H26.1332V42.5578H25.1063Z",
    fill: "#47525D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2469 46.3979V45.1187H31.2748V46.3979H30.2469Z",
    fill: "#47525D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 42.5588V41.2797H37.4279V42.5588H36.4Z",
    fill: "#47525D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3563 42.5578V45.1227H35.3832V42.5578H34.3563Z",
    fill: "#47525D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1594 45.1219V46.3998H29.2206V45.1219H27.1594Z",
    fill: "#47525D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 43.8391V45.1182H30.2467V43.8391H29.2188Z",
    fill: "#47525D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.325 40V41.2791H36.3529V40H35.325Z",
    fill: "#47525D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3312 42.5604V41.2812H34.3592V42.5604H33.3312Z",
    fill: "#47525D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1063 40.0016V41.2795H27.1599V40.0016H25.1063Z",
    fill: "#47525D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4352 45.0859V46.3557H40.4833V45.0859H38.4352Z",
    fill: "#47525D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4539 46.3569V45.0859H36.4325V46.3569H37.4539Z",
    fill: "#47525D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4758 43.8156V45.0866H37.4544V43.8156H38.4758Z",
    fill: "#47525D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5226 43.81V42.5391H41.544V43.81H40.5226Z",
    fill: "#47525D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5352 40.0016V42.5408H42.5556V40.0016H41.5352Z",
    fill: "#47525D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5571 42.5406V45.0892H43.5847V43.8194H44.6051V42.5406H42.5571Z",
    fill: "#47525D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6039 46.3569V45.0859H46.6253V46.3569H45.6039Z",
    fill: "#47525D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5352 46.3569V45.0859H42.5565V46.3569H41.5352Z",
    fill: "#47525D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M44.582 43.8156V45.0866H45.6034V43.8156H44.582Z",
    fill: "#47525D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6227 41.2703V43.8189H46.6431V41.2703H45.6227Z",
    fill: "#47525D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M43.582 40.0016V41.2713H45.6226V40.0016H43.582Z",
    fill: "#47525D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4321 42.5453V43.8151H38.4727V42.5453H36.4321Z",
    fill: "#47525D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4352 40V42.5486H39.4556V41.2698H40.476V40H38.4354H38.4352Z",
    fill: "#47525D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5297 47.6789V50.2438H54.5833V48.9568H53.5564V47.6789H52.5297Z",
    fill: "#47525D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5578 46.4008V47.6787H55.6115V46.4008H53.5578Z",
    fill: "#47525D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5859 50.2432V52.7987H56.6396V51.5208H55.6127V50.243L54.5859 50.2432Z",
    fill: "#47525D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4421 47.6789V48.9568H50.4691V50.2438H51.5033V47.6789H49.4421Z",
    fill: "#47525D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5015 46.4008V47.6799H52.5294V46.4008H51.5015Z",
    fill: "#47525D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M47.389 48.957V52.7998H48.416V51.5219H49.4429V50.244H48.416V48.957H47.389Z",
    fill: "#47525D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5297 52.7971V51.5179H53.5576V52.7971H52.5297Z",
    fill: "#47525D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6828 48.958V47.6789H59.7107V48.958H58.6828Z",
    fill: "#47525D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M56.639 48.957V51.5219H57.666V48.957H56.639Z",
    fill: "#47525D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4421 51.5211V52.799H51.5033V51.5211H49.4421Z",
    fill: "#47525D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5015 50.2383V51.5174H52.5294V50.2383H51.5015Z",
    fill: "#47525D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6078 46.3992V47.6783H58.6357V46.3992H57.6078Z",
    fill: "#47525D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M55.614 48.9596V47.6805H56.6419V48.9596H55.614Z",
    fill: "#47525D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M47.389 46.4008V47.6787H49.4427V46.4008H47.389Z",
    fill: "#47525D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7203 51.4851V52.7549H62.7684V51.4851H60.7203Z",
    fill: "#47525D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M59.739 52.7561V51.4851H58.7176V52.7561H59.739Z",
    fill: "#47525D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7609 50.2148V51.4858H59.7395V50.2148H60.7609Z",
    fill: "#47525D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8078 50.2092V48.9383H63.8292V50.2092H62.8078Z",
    fill: "#47525D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8203 46.4008V48.94H64.8407V46.4008H63.8203Z",
    fill: "#47525D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8422 48.9398V51.4884H65.8698V50.2186H66.8902V48.9398H64.8422Z",
    fill: "#47525D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M67.889 52.7561V51.4851H68.9104V52.7561H67.889Z",
    fill: "#47525D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8203 52.7561V51.4851H64.8417V52.7561H63.8203Z",
    fill: "#47525D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8672 50.2148V51.4858H67.8886V50.2148H66.8672Z",
    fill: "#47525D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9078 47.6695V50.2181H68.9282V47.6695H67.9078Z",
    fill: "#47525D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8672 46.4008V47.6705H67.9078V46.4008H65.8672Z",
    fill: "#47525D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7172 48.9445V50.2143H60.7577V48.9445H58.7172Z",
    fill: "#47525D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7203 46.3992V48.9478H61.7407V47.669H62.7611V46.3992H60.7205H60.7203Z",
    fill: "#47525D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2469 47.6789V50.2438H32.3005V48.9568H31.2736V47.6789H30.2469Z",
    fill: "#47525D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M31.275 46.4008V47.6787H33.3287V46.4008H31.275Z",
    fill: "#47525D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3031 50.2432V52.7987H34.3568V51.5208H33.3298V50.243L32.3031 50.2432Z",
    fill: "#47525D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1594 47.6789V48.9568H28.1863V50.2438H29.2206V47.6789H27.1594Z",
    fill: "#47525D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 46.4008V47.6799H30.2467V46.4008H29.2188Z",
    fill: "#47525D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1063 48.957V52.7998H26.1332V51.5219H27.1601V50.244H26.1332V48.957H25.1063Z",
    fill: "#47525D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2469 52.7971V51.5179H31.2748V52.7971H30.2469Z",
    fill: "#47525D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 48.958V47.6789H37.4279V48.958H36.4Z",
    fill: "#47525D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3563 48.957V51.5219H35.3832V48.957H34.3563Z",
    fill: "#47525D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1594 51.5211V52.799H29.2206V51.5211H27.1594Z",
    fill: "#47525D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 50.2383V51.5174H30.2467V50.2383H29.2188Z",
    fill: "#47525D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M35.325 46.3992V47.6783H36.3529V46.3992H35.325Z",
    fill: "#47525D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3312 48.9596V47.6805H34.3592V48.9596H33.3312Z",
    fill: "#47525D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1063 46.4008V47.6787H27.1599V46.4008H25.1063Z",
    fill: "#47525D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4352 51.4851V52.7549H40.4833V51.4851H38.4352Z",
    fill: "#47525D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4539 52.7561V51.4851H36.4325V52.7561H37.4539Z",
    fill: "#47525D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4758 50.2148V51.4858H37.4544V50.2148H38.4758Z",
    fill: "#47525D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5226 50.2092V48.9383H41.544V50.2092H40.5226Z",
    fill: "#47525D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5352 46.4008V48.94H42.5556V46.4008H41.5352Z",
    fill: "#47525D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5571 48.9398V51.4884H43.5847V50.2186H44.6051V48.9398H42.5571Z",
    fill: "#47525D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6039 52.7561V51.4851H46.6253V52.7561H45.6039Z",
    fill: "#47525D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5352 52.7561V51.4851H42.5565V52.7561H41.5352Z",
    fill: "#47525D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M44.582 50.2148V51.4858H45.6034V50.2148H44.582Z",
    fill: "#47525D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6227 47.6695V50.2181H46.6431V47.6695H45.6227Z",
    fill: "#47525D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M43.582 46.4008V47.6705H45.6226V46.4008H43.582Z",
    fill: "#47525D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4321 48.9445V50.2143H38.4727V48.9445H36.4321Z",
    fill: "#47525D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4352 46.3992V48.9478H39.4556V47.669H40.476V46.3992H38.4354H38.4352Z",
    fill: "#47525D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverLicense);
export default __webpack_public_path__ + "static/media/DriverLicense.b6be035bba739483d20c2060f3bb0a2b.svg";
export { ForwardRef as ReactComponent };